import React, {Component} from "react";
import {Calendar} from "primereact/calendar";
import DateUtil from "../../utils/DateUtil";

// Date filter used across the insurance tabs. Default is range mode: value is
// [startDate, endDate|null] and callers should act only when both ends are set.
// With the `single` prop, value/onChange carry one Date instead.
class PrimeDateRangeInput extends Component {

    render() {
        const {value, onChange, single, style, inputStyle, ...rest} = this.props;

        return <Calendar
            value={value}
            onChange={(e) => onChange(e.value)}
            selectionMode={single ? "single" : "range"}
            readOnlyInput
            dateFormat="dd-M-yy"
            placeholder={single ? "Select date" : "Select date range"}
            showIcon
            monthNavigator
            yearNavigator
            yearRange={`${DateUtil.currentYear() - 100}:${DateUtil.currentYear() + 100}`}
            appendTo={document.body}
            baseZIndex={1400}
            {...rest}
            style={{width: single ? '160px' : '230px', ...style}}
            inputStyle={{width: single ? '130px' : '200px', ...inputStyle}}
        />;
    }

}

export default PrimeDateRangeInput;
